import { useCallback } from 'react';
import { useChatActions } from './useChatActions';
import { useChatBootstrap } from './useChatBootstrap';
import { useChatSocket } from './useChatSocket';
import { useChatUploads } from './useChatUploads';
import { useFetchRecipientUser } from './useFetchRecipientUser';
import { useErrorStore } from '../stores/useErrorStore';
import { useAuthStore } from '../stores/useAuthStore';
import { useChatViewStore } from '../stores/useChatViewStore';
import { useSocketStore } from '../stores/useSocketStore';
import { useTicketStore } from '../stores/useTicketStore';

export function useChatRuntime(user) {
  const socket = useSocketStore((state) => state.socket);
  const onlineUsers = useSocketStore((state) => state.onlineUsers);

  const currentChat = useTicketStore((state) => state.currentChat);
  const internalChats = useTicketStore((state) => state.internalChats);
  const openTickets = useTicketStore((state) => state.openTickets);
  const userChatsQueue = useTicketStore((state) => state.userChatsQueue);
  const sortedChats = useTicketStore((state) => state.sortedChats);

  const scrollChatToBottom = useChatViewStore((state) => state.scrollChatToBottom);
  const setIsInitialMount = useChatViewStore((state) => state.setIsInitialMount);

  const logoutUser = useAuthStore((state) => state.logoutUser);
  const setErrorMessage = useErrorStore((state) => state.setErrorMessage);
  const { recipientUser } = useFetchRecipientUser(currentChat, user);
  const { fetchMediaUrls, fetchMessages } = useChatActions();

  const handleScrollChatToBottom = useCallback(() => {
    scrollChatToBottom();
    setIsInitialMount(false);
  }, [scrollChatToBottom, setIsInitialMount]);

  const playOpenChatNotification = useCallback(() => {
    const notificationSound = new Audio(
      'https://chat.telein.com.br/assets/audios/openchatnotification.mp3',
    );

    notificationSound.play().catch(() => {});
  }, []);

  const playNotificationSound = useCallback(() => {
    const notificationSound = new Audio(
      'https://chat.telein.com.br/assets/audios/notificationsound.mp3',
    );

    notificationSound.play().catch(() => {});
  }, []);

  useChatBootstrap(user);
  useChatUploads();
  useChatSocket({
    user,
    socket,
    currentChat,
    internalChats,
    openTickets,
    userChatsQueue,
    sortedChats,
    recipientUser,
    onlineUsers,
    logoutUser,
    fetchMediaUrls,
    fetchMessages,
    handleScrollChatToBottom,
    playNotificationSound,
    playOpenChatNotification,
    setErrorMessage,
  });
}
